import React, { useState } from 'react';
import { Button } from '../buttons/button';
import { cn } from '../../lib/utils';
import { FormListIcon } from '../Icons/svgIcons';

const FormCard = ({ title, projectId, projectName, description, submissionsExists, status, page = 'default', onAction, onViewLists }) => {
  const isDraft = status === 'draft';
  const isPublished = status === 'published' || status === 'active' || !status;
  const [isExpanded, setIsExpanded] = useState(false);

  // Consider true if it's explicitly true, "true", or 1.
  const hasSubmissions = submissionsExists === true || submissionsExists === "true" || submissionsExists === 1;
  const showNoSubmissions = submissionsExists === false || submissionsExists === null || submissionsExists === undefined;

  const renderButtons = () => {
    if (page === 'forms') {
      return (
        <Button 
          onClick={onAction} 
          variant="primary" 
          size="large" 
          fullWidth 
          disabled={isDraft} 
          className="font-semibold"
        >
          Start Now
        </Button>
      );
    }
    
    return (
      <div className="relative">
        <Button 
          onClick={onViewLists} 
          disabled={!hasSubmissions || isDraft} 
          variant="outline" 
          size="default" 
          fullWidth 
          className={cn(
            "font-semibold border-2 transition-all duration-200",
            isDraft 
              ? "border-gray-300 text-gray-400 bg-gray-50" 
              : "border-[var(--btn-primary-bg)] text-[var(--btn-primary-bg)] bg-[var(--btn-primary-bg)]/5 hover:bg-[var(--btn-primary-bg)]/10"
          )}
        >
        <FormListIcon className="w-4 h-4 text-btn-primary mr-2" />
          View Lists
        </Button>
      </div>
    );
  };

  return (
    <div className="bg-white rounded-xl border-2 border-gray-200 overflow-hidden p-4 flex flex-col justify-between h-full min-h-[150px] shadow-sm transition-all duration-300 hover:shadow-lg hover:-translate-y-0.5 relative overflow-hidden">
      <div className="absolute top-0 right-0 m-0">
        <span className={cn("text-[11px] font-bold px-3 py-2 rounded-bl-xl uppercase tracking-wide", isPublished ? "bg-green-100 text-green-700" : "bg-yellow-100 text-yellow-700")}>
          {isPublished ? 'Active' : 'Draft'}
        </span>
      </div>

      <div className="mb-3 flex-1">
        <h3 className="text-gray-900 font-bold text-base mb-1 leading-tight line-clamp-2 pr-16">{title}</h3>
        
        {projectName && (
          <div className="text-xs font-semibold text-gray-500 mb-2 truncate pr-16" title={projectName}>
            Project: <span className="text-gray-600">
              {projectName}
            </span>
          </div>
        )}
        
        <p 
          className={cn(
            "text-xs text-gray-600 leading-relaxed",
            !isExpanded && "line-clamp-2"
          )}
        >
          {description || "No description provided for this form."}
        </p>
        {description && description.length > 80 && (
          <button 
            onClick={e => { e.stopPropagation(); setIsExpanded(!isExpanded); }}
            className="flex items-center gap-1 text-[11px] text-[var(--header-bg)] font-bold mt-1.5 hover:underline transition-colors"
          >
            {isExpanded ? "Show Less" : "Read More"}
            <svg className={cn("w-3.5 h-3.5 transition-transform duration-200", isExpanded && "rotate-180")} fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
        )}
        
        {showNoSubmissions && (
          <div className="flex items-center gap-1.5 mt-3">
            <span className="flex w-2 h-2 bg-gray-300 rounded-full"></span>
            <span className="text-xs font-semibold text-gray-400">No submissions yet</span>
          </div>
        )}
      </div>
      
      <div className="mt-auto pt-3 border-t border-gray-50">
        {renderButtons()}
      </div>
    </div>
  );
};

export default FormCard;